import { h, Fragment } from "preact";
import { useState, useRef, useContext } from "preact/hooks";
import ADControls from "./AudioDescription/components/ADControls";
import MediaPlayer from "./MediaPlayer/MediaPlayer";
import Transcript from "./transcript/components/Transcript";
import SearchProvider from "./features/utils/SearchProvider";
import ADPlayer from "./AudioDescription/components/ADPlayer";
import { RootDataType } from "../types/rootDataTypes";

import SettingsContext from "./SettingsContext";
import { Footer } from "./shared/components";
import { playerInterface, subscribeToTimer } from "./timer/timer-manager";

/**
 * Component for sharing state between features
 * Listens to onPlay and onPause
 * Shares state via playing prop on renderPlayer
 */

const RecordedContainer = ({
  available_audio_description_languages: adLangs,
  available_transcript_languages: tranLangs,
  name: mediaName,
}: RootDataType): h.JSX.Element => {
  const { settings } = useContext(SettingsContext);

  const [adEnabled, setAdEnabled] = useState<boolean>(false);
  const transcriptRef = useRef<HTMLDivElement>(null);

  const jumpToTranscript = () => {
    const firstFocusableElement = transcriptRef.current?.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ) as HTMLElement | undefined;
    firstFocusableElement?.scrollIntoView();
    firstFocusableElement?.focus();
  };

  const renderAd = settings.showAd && Object.keys(adLangs).length > 0;
  const renderTranscript =
    settings.showTranscript && Object.keys(tranLangs).length > 0;

  return (
    <>
      <div class="RecordedContainer-header">
        <h2 class="RecordedContainer-title">{mediaName}</h2>
        {(renderAd || renderTranscript) && (
          <div class="RecordedContainer-controls posRelative noOverflow">
            {renderAd && (
              <ADControls toggled={adEnabled} onToggle={setAdEnabled} />
            )}
            {renderTranscript && (
              <button
                data-testid="skiplink"
                class="skipLink"
                onClick={() => jumpToTranscript()}
              >
                Skip to Transcript
              </button>
            )}
          </div>
        )}
      </div>
      <MediaPlayer hasAD={renderAd} controls width="100%" />
      {/** TODO: Move into MediaPlayer */}
      {renderAd && <ADPlayer muted={!adEnabled} />}

      {renderTranscript ? (
        <SearchProvider>
          <Transcript
            tranLangs={tranLangs}
            onWordClick={(val) => {
              playerInterface.value.seekTo(val);
            }}
            ref={transcriptRef}
          />
        </SearchProvider>
      ) : (
        <Footer />
      )}
    </>
  );
};

export default RecordedContainer;
